import axios from "axios";
import packageJson from "package.json";

export function createAxiosInstance({ apiUrl }: { apiUrl: string }) {
  const instance = axios.create({
    headers: {
      "x-data-version": packageJson.version,
    },
    baseURL: apiUrl,
    paramsSerializer: {
      indexes: null,
    },
  });
  instance.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error.response.status === 426) {
        window.location.reload();
      }
      return Promise.reject(error);
    },
  );
  return instance;
}
